<template>
	<div>
		<Layout :navFixed="true"  :withImage="true">
			<HomeSlider />

			<div style="margin-top:-100px">
				<HomeAbout />
			</div>

			<div>
				<HomeCategories />
			</div>

			<div style="margin-top:0px; padding:120px 0px 220px 0" class="container-fluid featured-products ">
				<div class="container">
					<div class="row ">
						<div class="col">
							<div class="section-title">
								<p class="title">OPORTUNIDADES</p>
								<h2>Nuestros destacados!</h2>
							</div>
							<FeaturedProducts />
						</div>
					</div>
				</div>
			</div>

			<!-- <div style="margin-top:100px" class="container-fluid  pb-5 pt-5">
				<div class="container">
					<div class="row ">
						<div class="col">
							<div class="section-title">
								<p class="title">Testimonios</p>
								<h2>Clientes satisfechos!</h2>
							</div>
							<HomeTestimonials />
						</div>
					</div>
				</div>
			</div> -->
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import HomeSlider from "@/views/home/HomeSlider"
import HomeBrandsAvailable from "@/views/home/HomeBrandsAvailable"
import FeaturedProducts from "@/views/home/FeaturedProducts"
import HomeSections from "@/views/home/HomeSections"
import HomeContact from "@/views/home/HomeContact"
import HomeAbout from "@/views/home/HomeAbout"
import HomeCategories from "@/views/home/HomeCategories"
import HomeTestimonials from "@/views/home/HomeTestimonials"

export default {
	name: "Home",
	components: {
		Layout,
		HomeSlider,
		HomeBrandsAvailable,
		FeaturedProducts,
		HomeSections,
		HomeContact,
		HomeCategories,
		HomeAbout,
		HomeTestimonials
	},
	data() {
		return {
			sectionWelcome: null,
			sectionQuality: null
		}
	},

	async beforeMount() {
		// this.sectionWelcome = await this.loadPage("welcome")
	},
	methods: {
		loadPage(page) {
			return this.$apollo
				.query({
					query: gql`
						query($slug: String!) {
							page(slug: $slug) {
								title
								intro
								body
							}
						}
					`,
					variables: {
						slug: page
					}
				})
				.then(({ data }) => {
					return data.page
				})
		}
	}
}
</script>

<style scoped>

</style>
